import React from "react";
import { Routes, Route } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts";

//routes
import { publicRoutes } from "./allRoutes";
import ErrorBoundary from "Components/Common/ErrorBoundary";
import Loader from "Components/Common/Loader";
import useRoutes from "./useRoutes";
import { consumerPaymentRoute } from "./constants";

const routesToExcludeLayout = [consumerPaymentRoute];

const Index = () => {
  const { isLoading, authRoutes } = useRoutes();
  if (isLoading) {
    return <Loader />;
  }

  return (
    <React.Fragment>
      <Routes>
        {authRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              routesToExcludeLayout.includes(route.path) ? (
                <ErrorBoundary>{route.component}</ErrorBoundary>
              ) : (
                <VerticalLayout>
                  <ErrorBoundary>{route.component}</ErrorBoundary>
                </VerticalLayout>
              )
            }
            key={idx}
            exact
          />
        ))}
        {publicRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <ErrorBoundary key={route.path}>
                <NonAuthLayout>{route.component}</NonAuthLayout>
              </ErrorBoundary>
            }
            key={idx}
            exact
          />
        ))}
      </Routes>
    </React.Fragment>
  );
};

export default Index;
